import { render, staticRenderFns } from "./spcodaccard.vue?vue&type=template&id=557f4911"
import script from "./spcodaccard.vue?vue&type=script&lang=js"
export * from "./spcodaccard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports